import React, { useEffect, useState } from 'react';
import { FaLeaf, FaMobileAlt, FaShoppingBag } from 'react-icons/fa';
import { getPlayStoreUrl } from './deepLink';
import './LandingPage.css';

const slides = [
  {
    image: 'https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?q=80&w=2940&auto=format&fit=crop',
    alt: 'A curated women’s fashion collection',
  },
  {
    image: 'https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?q=80&w=2940&auto=format&fit=crop',
    alt: 'Clothing displayed in a modern fashion shop',
  },
  {
    image: 'https://images.unsplash.com/photo-1525562723836-dca67a71d5f1?q=80&w=2940&auto=format&fit=crop',
    alt: 'A woman expressing her personal fashion style',
  },
];

const features = [
  {
    icon: FaShoppingBag,
    title: 'Buy and sell with confidence',
    text: 'Discover pre-loved women’s fashion or give pieces from your wardrobe a new home.',
  },
  {
    icon: FaLeaf,
    title: 'Make fashion last longer',
    text: 'Every resale helps extend the life of clothing and supports a more thoughtful wardrobe.',
  },
  {
    icon: FaMobileAlt,
    title: 'Everything happens in the app',
    text: 'Browse, list, bid, pay, message, and follow deliveries securely in the LadyFirst mobile app.',
  },
];

function LandingPage() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    document.title = 'LadyFirst | Pre-loved Fashion for Women';
    const slideInterval = window.setInterval(() => {
      setCurrentIndex((index) => (index + 1) % slides.length);
    }, 5000);

    return () => {
      window.clearInterval(slideInterval);
      document.title = 'LadyFirst';
    };
  }, []);

  return (
    <div className="landing-page">
      <section className="hero-banner" aria-labelledby="landing-title">
        {slides.map((slide, index) => (
          <img
            key={slide.image}
            src={slide.image}
            alt={slide.alt}
            className={`hero-slide ${index === currentIndex ? 'active' : ''}`}
            aria-hidden={index !== currentIndex}
          />
        ))}
        <div className="hero-overlay" />
        <div className="hero-text">
          <p className="hero-kicker">PRE-LOVED FASHION. MADE FOR WOMEN.</p>
          <h1 id="landing-title">Style gets a second story.</h1>
          <p>
            LadyFirst is a women’s fashion marketplace built for buying,
            selling, and giving beautiful clothing another life.
          </p>
          <a className="landing-app-button" href={getPlayStoreUrl()} target="_blank" rel="noreferrer">
            <FaMobileAlt aria-hidden="true" />
            Get the LadyFirst app
          </a>
        </div>
      </section>

      <section className="landing-introduction" aria-labelledby="about-ladyfirst">
        <p className="landing-section-label">ABOUT LADYFIRST</p>
        <h2 id="about-ladyfirst">A marketplace with purpose.</h2>
        <p>
          We connect women through style while making it easier to shop more
          consciously. From everyday favourites to statement pieces, LadyFirst
          keeps fashion moving between wardrobes instead of going to waste.
        </p>
      </section>

      <section className="landing-feature-grid" aria-label="Why use LadyFirst">
        {features.map(({ icon: Icon, title, text }) => (
          <article className="landing-feature-card" key={title}>
            <div className="landing-feature-icon"><Icon aria-hidden="true" /></div>
            <h3>{title}</h3>
            <p>{text}</p>
          </article>
        ))}
      </section>

      <section className="landing-app-callout">
        <div>
          <p className="landing-section-label">THE WEBSITE INFORMS. THE APP CONNECTS.</p>
          <h2>Ready to join LadyFirst?</h2>
          <p>Download the mobile app to explore the marketplace and use every LadyFirst feature.</p>
        </div>
        <a href={getPlayStoreUrl()} target="_blank" rel="noreferrer">Open the app store</a>
      </section>
    </div>
  );
}

export default LandingPage;
